import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import {isEmpty, postSubmit, scrollToComponent} from '@ui-seeker/utils'

import { isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import  {customerDetailsFilters } from "../../@signals";


export default function useCustomersKeywordsTableFilters() {

    const data = useSignal([])
    const isLoading = useSignal(false)
    const customerHasKeywords = useSignal(null)

    useEffect(() => {
        if (!isEmpty(customerDetailsFilters.value)) batch(() => {
            isLoading.value = true
            postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/customer-keywords`, customerDetailsFilters.value)
                .then(res => {
                    if (!res?.length)
                        customerHasKeywords.value = false
                    data.value = res
                    isLoading.value = false
                    customerHasKeywords.value = true
                })
                .catch(() => {
                    isSystemBusy.value = true
                }).finally(() => scrollToComponent('customer-keywords-info'))
        })

        if (isEmpty(customerDetailsFilters.value)) {
            data.value = {}
            isLoading.value = false
            customerHasKeywords.value = null
        }

    }, [JSON.stringify(customerDetailsFilters.value)])

    return {
        data: data.value,
        isLoading: isLoading.value,
        customerHasKeywords: customerHasKeywords.value,
    }
}